import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useFetchAuthorisation, useFetchUserData } from '../../utils/AppFunctions'
import config from '../../app-config'
import {
  create_dg_group,
  get_dg_group_by_id,
  update_dg_group,
  delete_dg_group,
  add_dg_member,
  get_all_dg_members_by_dg_id,
  get_all_dg_leaders_by_dg_id,
  remove_dg_member,
  update_dg_member,
  get_all_clusters
} from '../../api/dgAPI'
import { fetch_all_users_admin } from '../../api/usersAPI'
import 'react-toastify/dist/ReactToastify.css';
import AdminLayout from '../../layouts/AdminLayout'
import notify from '../../utils/IANotification';
import Select from 'react-select'
import Switch from 'react-switch'
import { DAYS } from '../../utils/helper';
import { MdPersonAdd, MdArrowBack, MdSave, MdDelete } from 'react-icons/md';
import ModalLayout from '../../layouts/ModalLayout';
import FileUploadField from '../../components/FileUploadField';
import SubNavbar from '../../components/ui/SubNavbar';
import Card from '../../components/ui/Card';
import Button from '../../components/ui/Button';

export default function DiscipleGroupFormPage() {
  const navigate = useNavigate()
  useFetchAuthorisation("user")
  useFetchUserData()

  let dg_id = new URLSearchParams(window.location.search).get("dg_id")

  const [activeTab, setActiveTab] = useState("general")

  const LANGUAGE = [
    { label: "English", value: "en" },
    { label: "Chinese", value: "ch" },
    { label: "Tamil", value: "ta" },
    { label: "Malay", value: "ml" },
  ]

  const tabs = [
    { id: 'general', label: 'General Profile' },
    { id: 'schedule_tags', label: 'Schedule & Tags' },
    { id: 'members', label: 'DG Members & Core' },
  ]

  const [dgClusterData, setDGClusterData] = useState([])
  const [showMemberModal, setShowMemberModal] = useState(false)
  const [tempUserData, setTempUserData] = useState({})
  const [temptags, setTemptags] = useState("")
  const [dgData, setDGData] = useState({
    name: "",
    description: "",
    day: "",
    datetime: "",
    is_accepting_members: 1,
    cluster_id: "",
    tagline: "",
    tags: [],
    language: "en",
  })
  const [dgMembers, setDgMembers] = useState([])
  const [dgLeaders, setDgLeaders] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchDGMembers()
    fetchDGLeaders()
    fetchPlatformUsers()
    fetchDGClusterData()
    fetchDGData()
  }, [])

  const fetchDGData = async () => {
    if (!dg_id || dg_id === "new") return
    const data = await get_dg_group_by_id(dg_id)
    if (data?.status === 200) {
      setDGData(data.data)
    }
  }

  const fetchDGMembers = async () => {
    if (!dg_id || dg_id === "new") return
    const data = await get_all_dg_members_by_dg_id(dg_id)
    if (data?.status === 200) {
      setDgMembers(data.data || [])
    }
  }

  const fetchDGClusterData = async () => {
    setLoading(true)
    const data = await get_all_clusters()
    if (data?.status === 200) {
      setDGClusterData(data.data || [])
    }
    setLoading(false)
  }

  const fetchDGLeaders = async () => {
    if (!dg_id || dg_id === "new") return
    const data = await get_all_dg_leaders_by_dg_id(dg_id)
    if (data?.status === 200) {
      setDgLeaders(data.data || [])
    }
  }

  const createDG = async () => {
    const data = await create_dg_group(dgData)
    if (data?.status === 200) {
      notify({ message: "Disciple Group created successfully", type: "success" })
      navigate("/admin/dg/details?dg_id=" + data.data.id)
    } else {
      notify({ message: data.message, type: "error" })
    }
  }

  const updateDG = async () => {
    const data = await update_dg_group(dg_id, dgData)
    if (data?.status === 200) {
      notify({ message: "Disciple Group updated successfully", type: "success" })
      fetchDGData()
    } else {
      notify({ message: data.message, type: "error" })
    }
  }

  const deleteDG = async () => {
    const data = await delete_dg_group(dg_id)
    if (data?.status === 200) {
      notify({ message: "Disciple Group deleted successfully", type: "success" })
      navigate("/admin/dg")
    } else {
      notify({ message: data.message, type: "error" })
    }
  }

  const addMember = async (member_id, role) => {
    const data = await add_dg_member({ dg_id: dg_id, user_id: member_id, role: role })
    if (data?.status === 200) {
      fetchDGMembers()
      fetchDGLeaders()
      notify({ message: "Member added", type: "success" })
    } else {
      notify({ message: data.message, type: "error" })
    }
  }

  const removeMember = async (member_id) => {
    const data = await remove_dg_member(dg_id, { user_id: member_id, dg_id: dg_id })
    if (data?.status === 200) {
      fetchDGMembers()
      fetchDGLeaders()
      notify({ message: "Member removed", type: "success" })
    } else {
      notify({ message: data.message, type: "error" })
    }
  }

  const updateMember = async (member_id, role) => {
    const data = await update_dg_member(dg_id, { user_id: member_id, dg_id: dg_id, role: role })
    if (data?.status === 200) {
      fetchDGMembers()
      fetchDGLeaders()
      notify({ message: "Role updated", type: "success" })
    } else {
      notify({ message: data.message, type: "error" })
    }
  }

  const fetchPlatformUsers = async () => {
    setLoading(true)
    const data = await fetch_all_users_admin()
    if (data?.status === 200) {
      setUsers(data.data || [])
    }
    setLoading(false)
  }

  const ROLES = [
    { label: "Member", value: 0 },
    { label: "DG Core", value: 1 },
  ]

  return (
    <AdminLayout
      navSelected={"Disciple Groups"}
      headerText={dg_id === "new" ? "New Disciple Group" : "Edit Disciple Group"}
      toolbar={
        <>
          <div className="flex items-center gap-3">
            <Button variant="outline" icon={MdArrowBack} onClick={() => navigate('/admin/dg')}>
              Back
            </Button>
            <h1 className='text-xl font-bold text-gray-900'>
              {dg_id === "new" ? "Create Disciple Group" : dgData.name || "Edit Disciple Group"}
            </h1>
          </div>
          <div className='flex gap-2'>
            {dg_id !== "new" && (
              <Button variant="danger" icon={MdDelete} onClick={deleteDG}>
                Delete
              </Button>
            )}
            <Button variant="primary" icon={MdSave} onClick={() => {
              if (dg_id === "new") createDG()
              else updateDG()
            }}>
              {dg_id === "new" ? "Create" : "Save Changes"}
            </Button>
          </div>
        </>
      }
    >
      <SubNavbar
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      />

      {/* Add Member Modal */}
      <ModalLayout isVisible={showMemberModal} setIsVisible={setShowMemberModal} modalTitle="Add Member to Disciple Group">
        <div className="space-y-4">
          <div className="input-container">
            <label className="input-label font-semibold">Select User</label>
            <Select
              options={users.map(user => ({ label: user.first_name + " " + user.last_name, value: user.id }))}
              onChange={(e) => setTempUserData(e)}
            />
          </div>
          <div className="input-container">
            <label className="input-label font-semibold">DG Role</label>
            <Select
              options={ROLES}
              onChange={(e) => setTempUserData({ ...tempUserData, role: e.value })}
            />
          </div>
          <div className="flex justify-end pt-2">
            <Button variant="primary" icon={MdPersonAdd} onClick={() => {
              addMember(tempUserData.value, tempUserData.role)
              setShowMemberModal(false)
            }}>
              Add Member
            </Button>
          </div>
        </div>
      </ModalLayout>

      {/* TAB 1: GENERAL PROFILE */}
      {activeTab === "general" && (
        <Card title="Disciple Group Profile" subtitle="Name, cluster zone, cover graphic, language, and overview.">
          {dg_id !== "new" && (
            <div className="mb-6">
              <FileUploadField
                upload_url={config.endpoint + "/file/dg/cover/id/" + dg_id}
                max_files={1}
                item_index={1}
                text={"Upload Group Photo"}
                max_file_size={"5"}
                onChange={() => fetchDGData()}
              />
            </div>
          )}

          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="input-container">
                <label className="input-label font-semibold">Group Name</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder='e.g. Truth Seekers'
                  value={dgData.name || ""}
                  onChange={(e) => setDGData({ ...dgData, name: e.target.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Cluster Zone</label>
                <Select
                  options={dgClusterData.map(cluster => ({ label: cluster.name, value: cluster.id }))}
                  value={dgClusterData.map(cluster => ({ label: cluster.name, value: cluster.id })).find(cluster => cluster.value == dgData.cluster_id)}
                  onChange={(e) => setDGData({ ...dgData, cluster_id: e.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Medium Language</label>
                <Select
                  options={LANGUAGE}
                  value={LANGUAGE.find(lang => lang.value === dgData.language)}
                  onChange={(e) => setDGData({ ...dgData, language: e.value })}
                />
              </div>
            </div>

            <div className="input-container">
              <label className="input-label font-semibold">Tagline</label>
              <input
                type="text"
                className="text-input"
                placeholder='e.g. Seeking the lost, grounded in scripture'
                value={dgData.tagline || ""}
                onChange={(e) => setDGData({ ...dgData, tagline: e.target.value })}
              />
            </div>

            <div className="input-container">
              <label className="input-label font-semibold">Description</label>
              <textarea
                className="textarea-input h-32"
                value={dgData.description || ""}
                onChange={(e) => setDGData({ ...dgData, description: e.target.value })}
                placeholder='e.g. We are a group of young adults meeting to study the Word and encourage one another...'
              />
            </div>
          </div>
        </Card>
      )}

      {/* TAB 2: SCHEDULE & TAGS */}
      {activeTab === "schedule_tags" && (
        <Card title="Meeting Schedule &amp; Tags" subtitle="Meeting times, open/closed status, and topical tags.">
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="input-container">
                <label className="input-label font-semibold">Meeting Day</label>
                <Select
                  options={DAYS}
                  value={DAYS.find(day => day.value === dgData.day)}
                  onChange={(e) => setDGData({ ...dgData, day: e.value })}
                />
              </div>

              <div className="input-container">
                <label className="input-label font-semibold">Meeting Time</label>
                <input
                  type="time"
                  className="text-input"
                  value={dgData.datetime || ""}
                  onChange={(e) => setDGData({ ...dgData, datetime: e.target.value })}
                />
              </div>
            </div>

            <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl border border-gray-200">
              <div>
                <label className="font-semibold text-sm text-gray-900">Membership Status</label>
                <p className="text-xs text-gray-500">Toggle whether this group is accepting new members.</p>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs font-semibold text-gray-700">
                  {dgData.is_accepting_members == 1 ? "Open to New Members" : "Closed Group"}
                </span>
                <Switch
                  checked={dgData.is_accepting_members == 1}
                  onChange={(e) => setDGData({ ...dgData, is_accepting_members: e ? 1 : 0 })}
                />
              </div>
            </div>

            <div>
              <div className="input-container">
                <label className="input-label font-semibold">Group Tags</label>
                <input
                  type="text"
                  className="text-input"
                  placeholder='Type a tag and press comma (e.g. Bible Study, Prayer, Youth)'
                  value={temptags}
                  onChange={(e) => {
                    if (e.target.value.includes(",")) {
                      const tagToAdd = e.target.value.split(",")[0].trim()
                      if (tagToAdd) {
                        setDGData({ ...dgData, tags: [...(dgData.tags || []), tagToAdd] })
                      }
                      setTemptags("")
                    } else {
                      setTemptags(e.target.value)
                    }
                  }}
                />
              </div>

              <div className="flex flex-wrap gap-2 mt-2">
                {dgData?.tags?.map((tag, index) => (
                  <span
                    key={index}
                    onClick={() => {
                      let tempTags = [...dgData.tags]
                      tempTags.splice(index, 1)
                      setDGData({ ...dgData, tags: tempTags })
                    }}
                    className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-xs font-semibold cursor-pointer hover:bg-red-100 hover:text-red-700 transition-all"
                  >
                    {tag} &times;
                  </span>
                ))}
              </div>
            </div>
          </div>
        </Card>
      )}

      {/* TAB 3: MEMBERS & CORE */}
      {activeTab === "members" && (
        <Card
          title="DG Core &amp; Member Roster"
          subtitle="Leaders and member assignments."
          headerRight={
            dg_id !== "new" && (
              <Button variant="primary" size="sm" icon={MdPersonAdd} onClick={() => setShowMemberModal(true)}>
                Add Member
              </Button>
            )
          }
        >
          {dg_id === "new" ? (
            <p className="text-xs text-gray-400 italic py-6 text-center">Save the group profile first before assigning members.</p>
          ) : (
            <div className="space-y-6">
              {/* DG Core */}
              <div>
                <h4 className="font-bold text-sm text-gray-900 mb-3">DG Core Leaders</h4>
                {dgLeaders?.length > 0 ? (
                  <div className="space-y-2">
                    {dgLeaders.map((leader, index) => (
                      <div key={index} className="flex items-center justify-between p-3.5 bg-gray-50 rounded-xl border border-gray-200">
                        <span
                          onClick={() => navigate("/admin/users/details?user_id=" + leader.user_id)}
                          className='font-bold text-xs text-blue-600 cursor-pointer hover:underline'
                        >
                          {leader?.user_data?.first_name} {leader?.user_data?.last_name}
                        </span>
                        <div className="w-36">
                          <Select
                            options={ROLES}
                            value={ROLES.find(role => role.value == leader.role)}
                            onChange={(e) => updateMember(leader.user_id, e.value)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-xs text-gray-400 italic">No DG Core leaders assigned.</p>
                )}
              </div>

              {/* Members Roster */}
              <div className="pt-4 border-t border-gray-100">
                <h4 className="font-bold text-sm text-gray-900 mb-3">Regular Members</h4>
                {dgMembers?.filter(m => m.role != 1)?.length > 0 ? (
                  <div className="space-y-2">
                    {dgMembers.filter(m => m.role != 1).map((member, index) => (
                      <div key={index} className="flex items-center justify-between p-3.5 bg-gray-50 rounded-xl border border-gray-200">
                        <span
                          onClick={() => navigate("/admin/users/details?user_id=" + member.user_id)}
                          className='font-bold text-xs text-blue-600 cursor-pointer hover:underline'
                        >
                          {member?.user_data?.first_name} {member?.user_data?.last_name}
                        </span>
                        <div className="flex items-center gap-3">
                          <div className="w-36">
                            <Select
                              options={ROLES}
                              value={ROLES.find(role => role.value == member.role)}
                              onChange={(e) => updateMember(member.user_id, e.value)}
                            />
                          </div>
                          <Button variant="danger" size="sm" icon={MdDelete} onClick={() => removeMember(member.user_id)}>
                            Remove
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-xs text-gray-400 italic">No regular members assigned.</p>
                )}
              </div>
            </div>
          )}
        </Card>
      )}
    </AdminLayout>
  )
}
